import { render, staticRenderFns } from "./CardRenderItemComponent.vue?vue&type=template&id=3234e370"
import script from "./CardRenderItemComponent.vue?vue&type=script&lang=ts"
export * from "./CardRenderItemComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports